<!-- eslint-disable max-len -->
<template>
  <v-container grid-list-xs pa-6 style="padding-top: 80px !important">
    <v-layout row justify-center>
      <v-flex xs12 md6 xl3 pa-2>

        <!-- ══ WELCOME: Validación de documento ══ -->
        <div v-if="step === 'welcome'" class="px-4">
          <p class="text-center text-h4 font-weight-bold" style="color: #2800c8">¡Bienvenid@!</p>
          <p class="text-center font-weight-medium subtitle-1 py-4">A ser parte de la familia Konecta</p>

          <v-form ref="formWelcome" v-model="isValidWelcomeForm" :lazy-validation="false">
            <p class="text-center black--text font-weight-bold subtitle-1 mb-5 mt-6">
              Tipo de documento
            </p>
            <v-select
              v-model="welcomeData.selectDocumentType"
              class="grey-label"
              color="#2800C8"
              :items="availableDocuments"
              :rules="[(v) => !!v || 'El tipo de documento es requerido']"
              label="Tipo de documento"
              placeholder="Seleccionar"
              outlined
              required
            />

            <p class="text-center black--text font-weight-bold subtitle-1 mb-2 mt-2">
              Número de documento
            </p>

            <!-- DNI -->
            <v-text-field
              v-if="isDni"
              v-model="welcomeData.documentNumber"
              class="grey-label"
              label="Número de documento"
              type="number"
              maxlength="8"
              outlined
              pattern="[0-9]*"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="dniRules"
              placeholder="Ingrese el número"
              required
            />
            <!-- Pasaporte -->
            <v-text-field
              v-if="welcomeData.selectDocumentType === 'Pasaporte'"
              v-model="welcomeData.documentNumber"
              class="grey-label"
              maxlength="11"
              outlined
              label="Número de pasaporte"
              type="number"
              pattern="[0-9]*"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="passportRules"
              placeholder="Ingrese el número de pasaporte"
              required
              oncopy="return false"
              onpaste="return false"
            />
            <!-- CE / PTP -->
            <v-text-field
              v-if="isCeOrPtp"
              v-model="welcomeData.documentNumber"
              class="grey-label"
              maxlength="9"
              outlined
              label="Número de documento"
              type="number"
              pattern="[0-9]*"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="temporaryPermitRules"
              placeholder="Ingrese el número de documento"
              required
              oncopy="return false"
              onpaste="return false"
            />

            <!-- Confirmación DNI -->
            <v-text-field
              v-if="isDni"
              v-model="welcomeData.documentConfirmationNumber"
              class="grey-label"
              type="number"
              maxlength="8"
              outlined
              label="Confirmación de documento"
              pattern="[0-9]*"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="dniRules"
              placeholder="Confirmación del número"
              required
            />
            <!-- Confirmación Pasaporte -->
            <v-text-field
              v-if="welcomeData.selectDocumentType === 'Pasaporte'"
              v-model="welcomeData.documentConfirmationNumber"
              class="grey-label"
              maxlength="11"
              outlined
              label="Confirmación del número"
              type="number"
              pattern="[0-9]*"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="passportRules"
              placeholder="Confirmación del número de pasaporte"
              required
              oncopy="return false"
              onpaste="return false"
            />
            <!-- Confirmación CE / PTP -->
            <v-text-field
              v-if="isCeOrPtp"
              v-model="welcomeData.documentConfirmationNumber"
              class="grey-label"
              maxlength="9"
              outlined
              label="Confirmación del número"
              type="number"
              pattern="[0-9]*"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @keypress="isNumber($event)"
              :rules="temporaryPermitRules"
              placeholder="Confirmación del número de documento"
              required
              oncopy="return false"
              onpaste="return false"
            />

            <v-alert v-if="dniNotMatch" class="my-5 px-5 mx-4" text dense color="red">
              No se encontraron coincidencias, verifique el número de documento y vuelva a ingresar en el campo.
            </v-alert>

            <v-row class="justify-center py-6">
              <v-checkbox
                color="#2800C8"
                v-model="privacyPolicyCheckbox"
                :rules="[(v) => !!v || '¡Acepta la política de Privacidad!']"
                required
                @click="trackCheckPoliticaPriv"
              >
                <template v-slot:label>
                  <div @click.stop style="font-size: 16px" class="black--text">
                    He leído y acepto la
                    <a
                      style="background: none; color: #2800C8"
                      href="/politica-de-privacidad"
                      target="_blank"
                      rel="noopener noreferrer"
                      @click.stop
                    >
                      Política de Privacidad de los postulantes
                    </a>
                  </div>
                </template>
              </v-checkbox>
            </v-row>

            <div class="d-flex justify-center">
              <v-btn
                width="250"
                height="45"
                :loading="isLoadingSend"
                :disabled="!isValidWelcomeForm"
                color="#2800C8"
                class="white--text"
                @click="validateDocument"
              >
                Enviar
              </v-btn>
            </div>
          </v-form>

          <TermsAndConditionsModal v-model="showTermsModal" />
          <ModalValidate v-model="showModalValidate" :type="modalType" :postulantData="postulantData" />
          <AlertComponent :show.sync="alert.show" :message="alert.message" :type="alert.type" />
        </div>

        <!-- Modal de consentimiento -->
        <InitModal
          v-model="showInitModal"
          description="Te pediremos algunos datos básicos para iniciar con tu proceso de selección*"
          disclaimer="*Tus datos serán tratados conforme a nuestra Política de Privacidad, únicamente para gestionar tu proceso de selección."
          @acceptPermission="onAcceptPermission"
          @check="trackCheck"
        />

        <!-- ══ PASOS DEL FORMULARIO RÁPIDO ══ -->
        <div v-if="step !== 'welcome' && step !== 'done'">

          <!-- Barra de progreso -->
          <div class="d-flex align-content-space-around mb-2">
            <v-progress-linear
              :value="progressValue"
              color="#2800C8"
              height="20"
              style="border-radius: 100px"
            >
              <template v-slot="{ value }">
                <strong class="white--text body-2" v-if="progressValue > 0">
                  {{ Math.ceil(value) }}%
                </strong>
              </template>
            </v-progress-linear>
          </div>

          <!-- ── PASO 1: Quién eres ── -->
          <div v-if="step === 1" class="justify-center text-center" style="margin-bottom: 70px">
            <v-form ref="form1" v-model="form1Valid" lazy-validation>
              <p class="text-center black--text font-weight-bold subtitle-1 mt-8 mb-0">
                1. Cuéntanos sobre ti
              </p>
              <v-img
                src="@/assets/profesionales.png"
                aspect-ratio="1.7"
                contain
                style="border-radius: 50%"
              />
              <p class="grey--text text--darken-1 subtitle-1 text-center pt-4 mb-6">
                Asegúrate de escribir tus datos tal como aparecen en tu documento de identidad.
              </p>

              <v-text-field
                v-model.trim="form.nombres"
                :rules="nameRules"
                outlined
                color="#2800C8"
                label="Nombre(s)"
                class="grey-label"
                maxlength="40"
              />
              <v-text-field
                v-model.trim="form.apellidoPaterno"
                :rules="nameRules"
                outlined
                color="#2800C8"
                label="Apellido Paterno"
                class="grey-label"
                maxlength="30"
              />
              <v-text-field
                v-model.trim="form.apellidoMaterno"
                :rules="nameRules"
                outlined
                color="#2800C8"
                label="Apellido Materno"
                class="grey-label"
                maxlength="30"
              />

              <p class="text-center black--text font-weight-bold subtitle mb-0 mt-2">
                ¿Cuál es tu número de celular?
              </p>
              <p class="caption grey--text text--darken-2 mb-4">
                Te contactaremos por este medio para coordinar tu proceso.
              </p>
              <v-text-field
                v-model.trim="form.telefono"
                :rules="phoneRules"
                outlined
                color="#2800C8"
                label="Número de celular"
                class="grey-label"
                maxlength="9"
                type="tel"
                prepend-inner-icon="mdi-cellphone"
                @keypress="isNumber($event)"
              />

              <v-btn block color="#2800C8" class="white--text mt-2" large @click="nextStep(1)">
                Siguiente
              </v-btn>
            </v-form>
          </div>

          <!-- ── PASO 2: Correo + OTP ── -->
          <div v-if="step === 2" class="justify-center text-center" style="margin-bottom: 70px">
            <v-form ref="form2" v-model="form2Valid" lazy-validation>
              <p class="text-center black--text font-weight-bold subtitle-1 mt-8 mb-0">
                2. Datos de contacto
              </p>
              <p class="grey--text text--darken-1 subtitle-1 text-center pt-2 mb-4">
                Asegúrate de registrar el correo que usas habitualmente.
                Se enviará un código de verificación por correo electrónico.
              </p>

              <div v-if="!isOtpLoading">
                <v-text-field
                  v-model.trim="form.correo"
                  :rules="emailRules"
                  label="Correo electrónico"
                  placeholder="example@gmail.com"
                  outlined
                  color="#2800C8"
                  prepend-inner-icon="mdi-email"
                  hide-details="auto"
                  class="grey-label mb-2"
                  :disabled="otpSent"
                  @copy.prevent
                  @paste.prevent
                />

                <v-btn
                  v-if="!otpSuccess"
                  block
                  color="#2800C8"
                  :style="otpSent || !form.correo || !isEmailValid ? 'color: #999' : 'color: #fff'"
                  class="mb-6 mt-1"
                  @click="sendOtp"
                  :disabled="otpSent || !form.correo || !isEmailValid"
                >
                  Enviar token
                  <span v-if="otpSent"> ({{ countdownDisplay }})</span>
                </v-btn>

                <p class="caption grey--text text--darken-2 mb-2" v-if="otpSent && !otpSuccess">
                  Se le envió un código de verificación por correo electrónico.
                </p>

                <v-text-field
                  v-if="!otpSuccess"
                  v-model.trim="form.otp"
                  outlined
                  class="grey-label"
                  label="Escribe el código que te hemos enviado"
                  color="#2800C8"
                  :rules="otpRules"
                  maxlength="6"
                  @input="onOtpInput"
                  :disabled="!otpSent"
                />
              </div>

              <v-progress-circular
                v-else
                indeterminate
                color="#2800C8"
                size="70"
                class="my-5 d-flex justify-center"
                style="width: 100%"
              />

              <v-alert v-if="otpSuccess" class="my-5 px-5 mx-4" text dense color="green">
                ¡Código correcto! Ya puedes continuar con tu proceso de selección.
              </v-alert>

              <v-btn
                block color="#2800C8" class="white--text mt-2" large
                :disabled="!otpSuccess"
                @click="nextStep(2)"
              >
                Siguiente
              </v-btn>
              <v-btn text block class="mt-2" @click="step = 1">Volver</v-btn>
            </v-form>
          </div>

          <!-- ── PASO 3: Distrito + Discapacidad ── -->
          <div v-if="step === 3" class="justify-center text-center" style="margin-bottom: 70px">
            <v-form ref="form3" v-model="form3Valid" lazy-validation>
              <p class="text-center black--text font-weight-bold subtitle-1 mt-8 mb-0">
                3. Datos adicionales
              </p>
              <p class="grey--text text--darken-1 subtitle-1 text-center pt-2 mb-6">
                Estamos casi listos. Solo un par de datos más.
              </p>

              <p class="text-center black--text font-weight-bold subtitle mb-0">
                ¿En cuál provincia vives?
              </p>
              <v-radio-group
                v-model="form.provincia"
                @change="onProvinciaChange"
                class="body-1 mt-4"
                :mandatory="false"
                :rules="requiredRule"
              >
                <v-radio label="Chiclayo" value="E" color="#2800C8" class="pa-2 radioStateCivil" />
                <v-radio label="Lima" value="A" color="#2800C8" class="pa-2 radioStateCivil" />
                <v-radio label="Piura" value="P" color="#2800C8" class="pa-2 radioStateCivil" />
                <v-radio label="Trujillo" value="T" color="#2800C8" class="pa-2 radioStateCivil" />
                <v-radio label="Arequipa" value="AREQUIPA" color="#2800C8" class="pa-2 radioStateCivil" />
                <v-radio label="Otra" value="OTHER" color="#2800C8" class="pa-2 radioStateCivil" />
              </v-radio-group>

              <v-expand-transition>
                <div v-if="form.provincia">
                  <p class="text-center black--text font-weight-bold subtitle mb-4">
                    ¿Cuál es tu distrito de residencia?
                  </p>
                  <v-select
                    v-if="form.provincia !== 'OTHER'"
                    v-model="form.distrito"
                    :items="availableDistricts"
                    :rules="requiredRule"
                    label="Distrito"
                    outlined
                    color="#2800C8"
                    item-color="#2800C8"
                    class="grey-label"
                  />
                  <v-text-field
                    v-else
                    v-model.trim="form.distrito"
                    :rules="[v => (!!v && v.trim().length > 0) || 'El distrito es requerido', v => /^[áéíóúÁÉÍÓÚñÑa-zA-Z\s]+$/.test(v) || 'Solo se aceptan letras']"
                    label="Distrito"
                    outlined
                    color="#2800C8"
                    class="grey-label"
                    maxlength="60"
                  />
                </div>
              </v-expand-transition>

              <p class="text-center black--text font-weight-bold subtitle mb-0 mt-2">
                ¿Cuentas con algún tipo de discapacidad?
              </p>
              <v-radio-group
                v-model="form.tieneDiscapacidad"
                class="body-1"
                :rules="[v => v !== null && v !== undefined || 'Este campo es obligatorio']"
              >
                <v-radio label="Sí" :value="true" color="#2800C8" class="pa-2 radioStateCivil" />
                <v-radio label="No" :value="false" color="#2800C8" class="pa-2 radioStateCivil" />
              </v-radio-group>

              <v-expand-transition>
                <div v-if="form.tieneDiscapacidad === true">
                  <p class="text-center black--text font-weight-bold subtitle mb-0 mt-2">
                    ¿Cuál es tu tipo de discapacidad?
                  </p>
                  <v-radio-group
                    v-model="form.tipoDiscapacidad"
                    class="body-1"
                    :mandatory="false"
                    :rules="form.tieneDiscapacidad ? requiredRule : []"
                  >
                    <v-radio
                      v-for="tipo in tiposDiscapacidad"
                      :key="tipo"
                      :label="tipo"
                      :value="tipo"
                      color="#2800C8"
                      class="pa-2 radioStateCivil"
                    />
                  </v-radio-group>
                </div>
              </v-expand-transition>

                      <v-alert v-if="submitError" class="my-4 px-5" text dense color="red">
                {{ submitError }}
              </v-alert>

              <v-btn
                block color="#2800C8" class="white--text mt-4" large
                :loading="isSubmitting"
                :disabled="isSubmitting"
                @click="submitForm"
              >
                Enviar postulación
              </v-btn>
              <v-btn text block class="mt-2" @click="step = 2">Volver</v-btn>
            </v-form>
          </div>
        </div>

        <!-- ══ CONFIRMACIÓN ══ -->
        <div v-if="step === 'done'" class="justify-center text-center" style="margin-bottom: 70px">
          <p class="text-center font-weight-bold text-h6 mb-2 mx-4" style="color: #2800C8">
            {{ form.nombres }}, ¡Estás a un paso de ser parte del equipo!
          </p>

          <p class="text-center mx-4 mb-6" style="font-size: 15px; color: #333">
            Para continuar con tu proceso debes agendar tu entrevista.
          </p>

          <v-alert
            color="#fff"
            class="mx-4 mb-4"
            style="border: 1px solid #FF9800 !important"
          >
            <div class="d-flex align-start">
              <v-icon color="#FF6600" size="24" class="mr-2 mt-0">mdi-alert</v-icon>
              <div style="color: #FF6600; font-size: 14px; line-height: 1.5">
                <strong>Copia tu link de acceso:</strong>
                Haz clic en el botón y guárdalo; lo necesitarás para agendar tu entrevista.
              </div>
            </div>
          </v-alert>

          <div class="d-flex align-center justify-center mx-4 mb-6" style="gap: 0px">
            <v-text-field
              :value="interviewLink"
              readonly
              outlined
              dense
              disabled
              hide-details
              style="max-width: 280px; flex: 1"
            />
            <v-btn
              outlined
              @click="copyInterviewLink"
              style="
                border: 2px solid #2800C8;
                color: #2800C8;
                font-weight: 600;
                text-transform: none;
                height: 40px;
                padding: 0 20px;
              "
            >
              Copiar link
            </v-btn>
          </div>

          <div class="text-center mb-6">
            <v-btn
              :color="linkCopied ? '#2800C8' : '#BDBDBD'"
              :class="linkCopied ? 'white--text' : 'grey--text text--darken-1'"
              :disabled="!linkCopied"
              @click="goToAgendarCita"
              x-large
              elevation="0"
              style="
                font-weight: 600;
                text-transform: none;
                padding: 0 48px;
                height: 48px;
                font-size: 15px;
                letter-spacing: 0.5px;
              "
            >
              AGENDAR MI ENTREVISTA
            </v-btn>
          </div>

          <v-btn text block class="mt-2" @click="$router.push('/')">
            Volver al inicio
          </v-btn>
        </div>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validateDocumentWithIGC, createMinimalPostulant, sendToken, validToken } from '@/services/dynamo/postulants';

export default {
  name: 'QuickFormPage',

  components: {
    InitModal: () => import('@/components/Agile Flow/init_modal.vue'),
    TermsAndConditionsModal: () => import('@/components/Agile Flow/terms_and_conditions_modal.vue'),
    ModalValidate: () => import('@/components/Agile Flow/modals/ModalValidate.vue'),
    AlertComponent: () => import('@/components/Notification.vue'),
  },

  props: {
    igc: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      // ── Welcome ──
      step: 'welcome',
      isValidWelcomeForm: true,
      isLoadingSend: false,
      dniNotMatch: false,
      privacyPolicyCheckbox: false,
      showTermsModal: false,
      showModalValidate: false,
      modalType: '',
      postulantData: {},
      alert: { show: false, message: '', type: 'info' },

      welcomeData: {
        selectDocumentType: '',
        documentNumber: '',
        documentConfirmationNumber: '',
      },

      availableDocuments: ['DNI', 'Pasaporte', 'Carnet de Extranjeria', 'Permiso Temporal de Permanencia'],

      LIST_CODE_ERRORS: ['ERR_POSTULATION_HAS_OPEN_PROCESS_ANOTHER_IGC'],

      // ── Init modal ──
      showInitModal: false,

      // ── Form steps ──
      isSubmitting: false,
      submitError: null,
      form1Valid: false,
      form2Valid: false,
      form3Valid: false,
      isOtpLoading: false,
      otpSent: false,
      otpSuccess: false,
      linkCopied: false,
      interviewLink: 'https://app-reclutamiento.vivekonecta.pe/agendar-cita-postulante',
      countdown: 0,
      timerId: null,

      form: {
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        telefono: '',
        correo: '',
        otp: '',
        provincia: null,
        distrito: null,
        tieneDiscapacidad: null,
        tipoDiscapacidad: '',
      },

      // ── Validaciones (iguales al flujo existente) ──
      dniRules: [
        v => !!v || 'El número de documento es requerido',
        v => (v && v.length === 8) || 'El número debe ser de 8 carácteres',
      ],
      passportRules: [
        v => !!v || 'El número de documento es requerido',
        v => (v && v.length === 11) || 'El número debe ser de 11 carácteres',
      ],
      temporaryPermitRules: [
        v => !!v || 'El número de documento es requerido',
        v => (v && v.length === 9) || 'El número debe ser de 9 carácteres',
      ],
      nameRules: [
        v => (!!v && v.trim().length > 0) || 'El nombre es requerido',
        v => /^[áéíóúÁÉÍÓÚñÑäöüÄÖÜ a-zA-Z]+$/.test(v) || 'Solo se aceptan letras, tilde y espacio',
      ],
      phoneRules: [
        v => !!v || 'Ingresa el número de celular',
        v => (v && v.length === 9) || 'El número debe ser de 9 dígitos',
        v => /^\d{0,9}$/.test(v) || 'El número debe ser de 9 dígitos',
      ],
      emailRules: [
        v => !!v || 'El correo es requerido',
        v => /.+@.+\..+/.test(v) || 'El correo no es válido',
      ],
      otpRules: [
        v => (v && v.length === 6) || 'El número debe ser de 6 caracteres',
      ],
      requiredRule: [v => !!v || 'Este campo es obligatorio'],

      availableDistricts: [],
      limaDistricts: [
        'Ancón', 'Ate', 'Barranco', 'Breña', 'Carabayllo', 'Chaclacayo',
        'Chorrillos', 'Cieneguilla', 'Comas', 'El agustino', 'Independencia',
        'Jesús María', 'La Molina', 'La Victoria', 'Lima', 'Lince',
        'Los Olivos', 'Lurigancho', 'Lurín', 'Magdalena del mar', 'Miraflores',
        'Pachacámac', 'Pucusana', 'Pueblo Libre', 'Puente Piedra', 'Punta Hermosa',
        'Punta Negra', 'Rímac', 'San Bartolo', 'San Borja', 'San Isidro',
        'San Juan de Lurigancho', 'San Juan de Miraflores', 'San Luis',
        'San Martin de Porres', 'San Miguel', 'Santa Anita', 'Santa María del Mar',
        'Santa Rosa', 'Santiago de Surco', 'Surquillo', 'Villa El Salvador',
        'Villa María del Triunfo',
      ],
      arequipaDistricts: [
        'Arequipa', 'Alto Selva Alegre', 'Cayma', 'Cerro Colorado', 'Characato',
        'Chiguata', 'Jacobo Hunter', 'Jose Luis Bustamante y Rivero', 'La Joya',
        'Mariano Melgar', 'Miraflores', 'Mollebaya', 'Paucarpata', 'Pocsi',
        'Polobaya', 'Quequeña', 'Sabandia', 'Sachaca', 'San Juan de Siguas',
        'San Juan de Tarucani', 'Santa Isabel de Siguas', 'Socabaya', 'Tiabaya',
        'Uchumayo', 'Vitor', 'Yanahuara', 'Yarabamba', 'Yura',
      ],
      trujilloDistricts: [
        'El Porvenir', 'Florencia de Mora', 'Huanchaco', 'La Esperanza', 'Laredo',
        'Moche', 'Poroto', 'Salaverry', 'Simbal', 'Trujillo', 'Víctor Larco Herrera',
      ],
      chiclayoDistricts: [
        'Cayaltí', 'Chiclayo', 'Chongoyape', 'Eten', 'Puerto Eten',
        'José Leonardo Ortiz', 'La Victoria', 'Lagunas', 'Monsefú', 'Nueva Arica',
        'Oyotún', 'Pátapo', 'Picsi', 'Pimentel', 'Pomalca', 'Pucalá', 'Reque',
        'Santa Rosa', 'Tumán', 'Zaña',
      ],
      piuraDistricts: [
        'Piura', 'Castilla', 'Catacaos', 'La Arena', 'La Unión', 'Las Lomas',
        'Tambo Grande', 'Cura Mori', 'El Tallán', 'Veintiséis de Octubre',
      ],

      tiposDiscapacidad: [
        'Discapacidad física (Tienes alguna/as limitación/es de forma permanente para moverte o caminar y/o para usar tus capacidades motoras o físicas)',
        'Discapacidad sensorial (Tienes alguna/as limitaciones de forma permanente para ver y/o incluso usando anteojos, hablar o comunicarte y/o inclusive usando lenguaje de señas, oír y/o incluso utilizando audiófonos medicados)',
        'Discapacidad intelectual (Tienes alguna/as limitaciones del funcionamiento intelectual que dificulta el desarrollo de habilidades sociales, intelectuales y de aprendizaje)',
        'Discapacidad psíquica (Tienes alguna/ limitaciones de tipo conductual y del comportamiento adaptativo)',
        'Discapacidad visceral (Tienes padecimiento de algún tipo de deficiencia en alguno de tus órganos y/o enfermedades como Diabetes o problemas cardíacos)',
        'Discapacidad múltiple (Presencia de dos o más limitaciones derivadas de algunas de las anteriores deficiencias)',
      ],
    };
  },

  computed: {
    isDni() {
      const t = this.welcomeData.selectDocumentType;
      return t !== 'Pasaporte' && t !== 'Permiso Temporal de Permanencia' && t !== 'Carnet de Extranjeria';
    },
    isCeOrPtp() {
      const t = this.welcomeData.selectDocumentType;
      return t === 'Permiso Temporal de Permanencia' || t === 'Carnet de Extranjeria';
    },
    isEmailValid() {
      return /.+@.+\..+/.test(this.form.correo);
    },
    countdownDisplay() {
      const m = Math.floor(this.countdown / 60).toString().padStart(2, '0');
      const s = (this.countdown % 60).toString().padStart(2, '0');
      return `${m}:${s}`;
    },
    progressValue() {
      const map = { 1: 0, 2: 33, 3: 66, done: 100 };
      return map[this.step] || 0;
    },
  },

  methods: {
    // ── Welcome ──
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      }
    },

    trackCheckPoliticaPriv() {
      this.$gtag?.event('QF_check_PoliticaDePrivacidad', {
        event_category: 'QF_check_PoliticaDePrivacidad',
        event_label: 'QF_check_PoliticaDePrivacidad',
        value: 1,
      });
    },

    handleError(error) {
      const errorCode = error?.response?.data?.code;
      switch (errorCode) {
        case 'ERR_PROCESS_NOT_FOUND':
          return { processNotFound: true };
        default:
          if (this.LIST_CODE_ERRORS.includes(errorCode)) {
            return { ...error?.response?.data?.payload, hasOpenProcess: true };
          }
          throw error;
      }
    },

    evaluatePostulantStatus(dataPostulant, igc) {
      if (!dataPostulant) return;
      const {
        isBlackList, completedForm, finishedTest, hasOpenProcess,
        isWorkingKonecta, processNotFound, processNotActive, testLink,
      } = dataPostulant;

      switch (true) {
        case isBlackList:
          this.modalType = 'blackList';
          this.showModalValidate = true;
          break;
        case completedForm && !finishedTest:
          this.modalType = 'pendingTest';
          if (testLink) sessionStorage.setItem('link-evaluar', testLink);
          this.showModalValidate = true;
          break;
        case completedForm && finishedTest:
          this.modalType = 'completedTest';
          this.showModalValidate = true;
          break;
        case hasOpenProcess:
          this.modalType = 'hasOpenProcess';
          this.showModalValidate = true;
          break;
        case isWorkingKonecta:
          this.modalType = 'isWorkingKonecta';
          this.showModalValidate = true;
          break;
        case processNotFound:
          this.modalType = 'processNotFound';
          this.showModalValidate = true;
          break;
        case processNotActive:
          this.modalType = 'processNotActive';
          this.showModalValidate = true;
          break;
        default:
          sessionStorage.setItem('igc-valid', igc);
          this.showInitModal = true;
      }
    },

    async validateDocument() {
      if (!this.$refs.formWelcome.validate()) return;

      const { documentNumber, documentConfirmationNumber } = this.welcomeData;
      if (documentNumber !== documentConfirmationNumber) {
        this.dniNotMatch = true;
        return;
      }
      this.dniNotMatch = false;
      this.isLoadingSend = true;

      try {
        const igcParam = this.igc || this.$route?.params?.igc;
        const data = await validateDocumentWithIGC(igcParam, documentNumber);
        this.postulantData = data?.data;
        this.evaluatePostulantStatus(data?.data, igcParam);
      } catch (error) {
        const handled = this.handleError(error);
        if (handled) {
          this.postulantData = handled;
          this.evaluatePostulantStatus(handled, this.igc || this.$route?.params?.igc);
        } else {
          this.alert = { show: true, message: 'Ocurrió un error durante la validación. Inténtalo de nuevo.', type: 'error' };
        }
      } finally {
        this.isLoadingSend = false;
      }
    },

    // ── Init modal ──
    onAcceptPermission() {
      this.step = 1;
      this.$gtag?.event('QF_btn_IniciarProceso', {
        event_category: 'QF_btn_IniciarProceso',
        event_label: 'QF_btn_IniciarProceso',
        value: 1,
      });
    },

    trackCheck() {
      this.$gtag?.event('QF_check_DatosPersonales', {
        event_category: 'QF_check_DatosPersonales',
        event_label: 'QF_check_DatosPersonales',
        value: 1,
      });
    },

    goToAgendarCita() {
      window.open(this.interviewLink, '_blank');
      this.$router.push('/empleos');
    },

    copyInterviewLink() {
      navigator.clipboard.writeText(this.interviewLink).then(() => {
        this.linkCopied = true;
      });
    },

    onProvinciaChange(provincia) {
      this.form.distrito = null;
      const map = {
        A: this.limaDistricts,
        AREQUIPA: this.arequipaDistricts,
        E: this.chiclayoDistricts,
        P: this.piuraDistricts,
        T: this.trujilloDistricts,
      };
      this.availableDistricts = map[provincia] || [];
    },

    // ── Form steps ──
    nextStep(current) {
      const valid = this.$refs[`form${current}`].validate();
      if (!valid) return;
      this.step = current + 1;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async sendOtp() {
      if (!this.isEmailValid) return;
      this.isOtpLoading = true;
      try {
        await this.$recaptchaLoaded();
        const gcaptcha = await this.$recaptcha('send_token');
        await sendToken(this.form.correo, gcaptcha);
        this.otpSent = true;
        this.countdown = 120;
        this.startCountdown();
      } catch (error) {
        console.error('Error al enviar token:', error);
      } finally {
        this.isOtpLoading = false;
      }
    },

    startCountdown() {
      if (this.timerId) clearInterval(this.timerId);
      this.timerId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timerId);
          this.timerId = null;
          this.otpSent = false;
        }
      }, 1000);
    },

    async onOtpInput(valor) {
      if (valor.length === 6) {
        this.isOtpLoading = true;
        try {
          await this.$recaptchaLoaded();
          const gcaptcha = await this.$recaptcha('validate_otp');
          const response = await validToken({ email: this.form.correo, token: valor, gcaptcha });
          if (response.success) {
            this.otpSuccess = true;
            if (this.timerId) clearInterval(this.timerId);
          } else {
            this.form.otp = '';
          }
        } catch (error) {
          console.error('Error al validar token:', error);
          this.form.otp = '';
        } finally {
          this.isOtpLoading = false;
        }
      }
    },

    async submitForm() {
      const valid = this.$refs.form3.validate();
      if (!valid) return;

      this.isSubmitting = true;
      this.submitError = null;

      try {
        await this.$recaptchaLoaded();
        const gcaptcha = await this.$recaptcha('create_postulant');

        const igc = this.igc || this.$route?.params?.igc;

        await createMinimalPostulant({
          igc,
          tipoDocumento: this.welcomeData.selectDocumentType,
          documento: this.welcomeData.documentNumber,
          nombres: this.form.nombres,
          apellidoPaterno: this.form.apellidoPaterno,
          apellidoMaterno: this.form.apellidoMaterno,
          telefono: this.form.telefono,
          correo: this.form.correo,
          distrito: this.form.distrito?.trim(),
          tieneDiscapacidad: this.form.tieneDiscapacidad,
          ...(this.form.tieneDiscapacidad && { tipoDiscapacidad: this.form.tipoDiscapacidad }),
        }, gcaptcha);

        this.$gtag?.event('QF_submit_postulacion', {
          event_category: 'QF_submit_postulacion',
          event_label: 'QF_submit_postulacion',
          value: 1,
        });

        this.step = 'done';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error) {
        const status = error?.response?.status;
        if (status === 409) {
          this.submitError = 'Ya existe una postulación activa con estos datos.';
        } else if (status === 400) {
          this.submitError = 'Los datos ingresados no son válidos. Revísalos e intenta nuevamente.';
        } else {
          this.submitError = 'Ocurrió un error al enviar tu postulación. Por favor, intenta nuevamente.';
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },

  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId);
  },

  created() {
    if (this.$gtag) {
      this.$gtag.pageview({
        page_title: 'Postulacion Rapida',
        page_path: '/postulacion-rapida',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.grey-label {
  ::v-deep .v-label {
    color: #757575 !important;
  }
}

.radioStateCivil {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 4px;
}

.subtitle {
  color: #1a1a2e !important;
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
</style>
